import { CheckoutFormComponentDef } from '@df/checkout/checkout-form.component.def';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { App } from '@df/core/app';
import { Address } from '@df/session/api/address-book/address';
import { ToAddressPipeService } from '@df/ui/common/to-address.pipe';

import { Directive } from '@angular/core';
@Directive()
export abstract class CheckoutDeliveryStatusComponentDef {
    /**
     * Public access to customer model
     */
    get customer() {
        return this.app.customer;
    }

    /**
     * Class constructor
     */
    constructor(public checkoutFormComponent: CheckoutFormComponentDef, private toAddressPipe: ToAddressPipeService, protected app: App) {}

    /**
     * Shipping method
     */
    get shippingMethod(): Checkout.IShippingMethod | undefined {
        return this.checkoutFormComponent.shippingMethod;
    }

    /**
     * If store pickup method is selected
     */
    get isSelfCollect(): boolean {
        return this.checkoutFormComponent.selfCollect;
    }

    /**
     * Selected store pickup id
     */
    get selfCollectStoreId(): number | undefined {
        return this.checkoutFormComponent.selfCollectStoreId;
    }

    /**
     * Shipping address
     */
    get shippingAddress(): Checkout.IAddress | undefined {
        return this.checkoutFormComponent.data.address.shipping;
    }

    /**
     * Shipping address
     */
    get shippingAddressModel(): Address | undefined {
        return this.toAddressPipe.transform(this.shippingAddress);
    }

    /**
     * Change email and go to step of given name
     */
    change(stepName: string = 'delivery') {
        this.checkoutFormComponent.goToStep(stepName);
    }
}
